import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from "../../../../../app.constant";
import { Observable, BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { NotificationService, FcmMessagingService } from "../../../../../services";
import { ErrorComponent } from '../../errorComponent/error.component';
import { WebNotification } from "../models/notification";

@Component({
  selector: 'notifications-list',
  templateUrl: './notification-list.html',
  styleUrls: ['./notification-list.scss']
})
export class NotificationsList implements OnInit {

  // pagination: any = {}
  @Input() isInfiniteScrollWindow: boolean = false
  // notificationList: BehaviorSubject<WebNotification[]> = []
  notificationCount: number
  errorObj: any

  constructor(
    private router: Router,
    private err: ErrorComponent,
    private route: ActivatedRoute,
    private msg: FcmMessagingService,
    private notificationService: NotificationService
  ) {
    this.notificationService.getNotificationsForNextPage(1);
  }

  ngOnInit(): void {
    if(Constants.Var.sslOn){
      this.msg.getPermission();
    }
    // this.msg.monitorRefresh();
    if (Constants.Var.sslOn) {
      this.msg.receiveMessages();
    } else {

    }
    this.notificationService.notificationList.subscribe((msgList: Array<any>) => {
      if (msgList)
        this.notificationCount = msgList.length;
    });
  }

  // fetchNotifications(nextPage: boolean = false) {
  // let getNoti = (nextPage && this.pagination.nextPage != null)
  //   ? this.notificationService.getNotifications({ pageNumber: this.pagination.nextPage })
  //   : this.notificationService.getNotifications()
  // getNoti.subscribe((res: any) => {
  //   if (res && !_.isEmpty(res.pagination)) {
  //     _.assignIn(this.pagination, res.pagination);
  //   }
  //   else {
  //     throw new Error("INVALID_RESPONSE");
  //   }
  //   if (_.get(res, 'result.notifications.length') > 0) {
  // this.notificationList = _.concat(this.notificationList, res.result.notifications)
  //   }
  // })
  // }

  successMessage() {
    this.err.renderSuccessMsg('Successfully Saved');
  }

  onScroll() {
    this.notificationService.getNotificationsForNextPage()
    // if (this.pagination.nextPage != null) this.fetchNotifications(true);
  }

  clickCard(_item: any, i: number, $event?: any) {
    let notificationListingURL = "/pages/notifications/list"
    /*if (this.router.url != notificationListingURL && $event.target && !$event.target.hasAttribute('href')) {
      this.router.navigate([notificationListingURL]);
    }*/
    // mark as read the notification
    if (_item && _item.messageId && _item.read == false) {
      _item.read = true
      this.notificationService.updateValue(_item, i)
      this.notificationService.updateUnreadMessageCount(-1)

      this.notificationService.markAsRead(_item.messageId).subscribe(res => { }, err => {
        _item.read = false
        this.notificationService.updateUnreadMessageCount(+1) // if mark-read api call fails, then re-increase the unread counter.
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/notification/notification-list/notification-list.component.ts